import { getFormattedDate } from "@krea/lender-features/utils/dateAndTimeUtils";
import CheckBox from "@krea/shared/design-system/fields/Checkbox";

export const OnboardingTask = ({
  onboardingStartedAt,
  creditAssessmentDoneAt,
  onChange,
  disabled,
  displayUrlClickedAt = false,
  signingLinkClickedAt,
}: {
  onChange: (
    value: boolean,
    type: "ONBOARDING_STARTED" | "CREDIT_ASSESSMENT_DONE",
  ) => void;
  onboardingStartedAt?: DateString | null;
  creditAssessmentDoneAt?: DateString | null;
  signingLinkClickedAt?: DateString | null;
  disabled?: boolean;
  displayUrlClickedAt?: boolean;
}) => {
  return (
    <div>
      <p className="my-5 font-semibold">Status of selected offer</p>
      {displayUrlClickedAt ? (
        <div className="mb-3 flex items-center  rounded-sm bg-primary-150 p-3">
          <CheckBox
            className="m-0 flex items-center"
            label={"Signing link clicked: "}
            checked={!!signingLinkClickedAt}
            disabled={true}
          />

          <p className="m-0 ml-2 flex items-center text-gray-600">
            {signingLinkClickedAt
              ? getFormattedDate(signingLinkClickedAt)
              : "No information"}
          </p>
          <span />
          <span />
        </div>
      ) : null}
      <div className="mb-3 flex  rounded-sm bg-primary-150 p-3">
        <CheckBox
          className="m-0 flex items-center"
          label={"Onboarding started: "}
          checked={!!onboardingStartedAt}
          onChange={(checked) => {
            onChange(checked, "ONBOARDING_STARTED");
          }}
          disabled={disabled}
        />
        <p className="m-0 ml-2 flex items-center text-gray-600">
          {onboardingStartedAt
            ? getFormattedDate(onboardingStartedAt)
            : "No information"}
        </p>
        <span />
        <span />
      </div>
      <div className="mb-3 flex items-center  rounded-sm bg-primary-150 p-3">
        <CheckBox
          className="m-0 flex items-center"
          label={"Credit assessment done: "}
          checked={!!creditAssessmentDoneAt}
          onChange={(checked) => {
            onChange(checked, "CREDIT_ASSESSMENT_DONE");
          }}
          disabled={disabled}
        />

        <p className="m-0 ml-2 flex items-center text-gray-600">
          {creditAssessmentDoneAt
            ? getFormattedDate(creditAssessmentDoneAt)
            : "No information"}
        </p>
        <span />
        <span />
      </div>
    </div>
  );
};
